import $ from 'jquery';
import './styles.scss';

const SELECTORS = {
  PRODUCT_CELL: '.comparison-table__product',
  CTA_BTNS_WRAPPER: '.comparison-table__cta .comparison-table__cellWrapper',
  CTA_MORE_BTN: '.comparison-table__more-button',
  CTA_GO_TO_BTN: '.comparison-table__cta .luna-button',
  NAME_CELL: '.comparison-table__name',
  COMPARE_BTN_WRAPPER: '.comparison-table__compare .comparison-table__cellWrapper',
  COMPARE_CELL: '.comparison-table__compare',
};

const SLIDE_COLUMN_TXT = 'slide columns for more';

export default class ModernMobileTable {
  static IDENTIFIER_CLASS = 'mobile-view';
  static SLIDE_INFO_CLASS = 'slide-info';
  static SLIDE_INFO_OFFSET = 13;

  constructor($table) {
    this.$table = $table;
  }

  initialize() {
    this.$table.addClass(ModernMobileTable.IDENTIFIER_CLASS);
    this.setElementsHandlers();
    this.registerEvents();
    this.moveCtaBtnsTo(SELECTORS.PRODUCT_CELL, SELECTORS.NAME_CELL, SELECTORS.PRODUCT_CELL);
    this.updateDynamicElements();
  }

  destroy() {
    this.$table.removeClass(ModernMobileTable.identifier);
    this.unregisterEvents();
    this.setStickyCellsHeight(true);
    this.moveCtaBtnsTo(SELECTORS.COMPARE_CELL, SELECTORS.CTA_BTNS_WRAPPER);
    this.removeSlideInfos();
  }

  reload() {
    this.unregisterEvents();
    this.moveCtaBtnsTo(SELECTORS.COMPARE_CELL, SELECTORS.CTA_BTNS_WRAPPER);
    this.initialize();
  }

  setElementsHandlers() {
    this.$tableWrapper = this.$table.parent();
    this.$tableRows = this.$table.find('tr');
    this.$stickyCells = this.$table.find(SELECTORS.PRODUCT_CELL);
    this.$ctaMoreBtns = this.$table.find(SELECTORS.CTA_MORE_BTN);
    this.$ctaGoToBtns = this.$table.find(SELECTORS.CTA_GO_TO_BTN);
    this.$tableBodyRows = this.$table.find('tbody tr');
    this.$compateBtnWrappers = this.$table.find(SELECTORS.COMPARE_BTN_WRAPPER);
  }

  registerEvents() {
    window.addEventListener('resize', this.onResize);
    this.$table.on('update', this.onUpdate);
  }

  unregisterEvents() {
    window.removeEventListener('resize', this.onResize);
    this.$table.off('update', this.onUpdate);
  }

  onResize = () => {
    this.updateDynamicElements();
  }

  onUpdate = () => {
    this.reload();
  }

  updateDynamicElements() {
    this.setStickyCellsHeight();
    this.updateSlideInfoPosition();
  }

  setStickyCellsHeight(isDestroyed = false) {
    this.$stickyCells.each((idx, element) => {
      const $element = $(element);
      let currentHeight = '';

      if (!isDestroyed) {
        const $parent = $element.parent();
        currentHeight = `${$parent.height()}px`;
      }

      $element.css('height', currentHeight);
    });
  }

  moveCtaBtnsTo(destCompareWrapperSelector, destMoreBtnSelector, destGoToBtnSelector = destMoreBtnSelector) {
    ModernMobileTable.moveBtnsTo(this.$ctaMoreBtns, destMoreBtnSelector);
    ModernMobileTable.moveBtnsTo(this.$compateBtnWrappers, destCompareWrapperSelector);
    ModernMobileTable.moveBtnsTo(this.$ctaGoToBtns, destGoToBtnSelector);
  }

  updateSlideInfoPosition() {
    this.$tableBodyRows.each((idx, row) => {
      const $row = $(row);
      const $slideInfo = ModernMobileTable.getSlideInfoElement($row);
      const rowBottomPosition = $row.position().top + $row.height();
      const infoPosition = rowBottomPosition - $slideInfo.height() - ModernMobileTable.SLIDE_INFO_OFFSET;

      $slideInfo.css('top', infoPosition);
    });
  }

  removeSlideInfos() {
    this.$tableBodyRows.find(`.${ModernMobileTable.SLIDE_INFO_CLASS}`).remove();
  }

  static getSlideInfoElement($row) {
    const $slideInfo = $row.find(`.${ModernMobileTable.SLIDE_INFO_CLASS}`);
    return $slideInfo.length ? $slideInfo : ModernMobileTable.createSlideInfoElement($row);
  }

  static createSlideInfoElement($row) {
    return $('<span>')
      .text(SLIDE_COLUMN_TXT)
      .addClass(ModernMobileTable.SLIDE_INFO_CLASS)
      .appendTo($row);
  }

  static moveBtnsTo($btns, destinationSelector) {
    $btns.each((idx, btn) => {
      const $btn = $(btn);
      const $destinantion = $btn.parents('tr').find(destinationSelector);

      $btn.detach().appendTo($destinantion);
    });
  }
}
